import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'TrendParagraph',
  components: {
    GlobalTitle: GlobalTitle
  },
  props: {
    initialColor: {
      type: String,
      default: '#3C3C3B'
    },
    title: {
      type: Object,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    buttonColor: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    buttonUrl: {
      type: String,
      required: true
    },
    quote: {
      type: String,
      default: ''
    }
  },
  computed: {
    initial: function initial() {
      return this.title.text.charAt(0).toUpperCase();
    }
  }
};